import { useState } from "react"
import { Stack, Row, Col, Button } from "react-bootstrap"
import { useApps } from "../../api/apps/store"
import useUXStore from "../../api/ux/store"
import Input from "../../components/Input"
import Label from "../../components/Label"
import { BranchData, useBranch } from "../../api/branch/store"

const defaultErr = {id:"",name:"",}

const AddBranchView = ({onAdded = (branch:BranchData) => {}, com=""}) => {
    const [adding,setAdding] = useState(false)
    const [branch,setBranch] = useState<BranchData>({id:"",name:""})
    const [err,setErr] = useState(defaultErr)
    const { refreshDialog, hideDialog, addToast } = useUXStore( state => state)
    const { addBranch } = useBranch(state => state)
    
    const onAdd = () => {
        setAdding(true)
        refreshDialog({
            id: "addBranch",
            onClose: undefined,
        }, false)
        setErr(defaultErr)
        addBranch(com, branch).then( code => {
            if (code === "200") {
                addToast("", branch.name + " successfully added!")
            } else {
                addToast("Failed", "Failed to add app " + branch.name)
            }
            switch (code) {
                case "200":
                    hideDialog("addBranch")
                    onAdded(branch)
                    break;
                case "app_enrolled": // already enrolled
                    setErr({id:"Id already taken.",name:""})
                    break;
                case "incomplete_param":
                    setErr({id:"Required", name:"Required"})
                    break
                default:
                    console.error(code)
                    break;
            }
        })
        .catch( err => {
            
        }).finally( () => {
            setAdding(false)
            refreshDialog({
                id: "addBranch",
            }, true)
        })
    }
    return <>
        <Stack gap={2}>
            <Row>
                <Col><Label>Id</Label> </Col>
                <Col><Input disabled={adding} label={err.id} error onChange={(e:any) => setBranch({...branch,id:e.target.value})}/> </Col>
            </Row>
            <Row>
                <Col><Label>Name</Label> </Col>
                <Col><Input disabled={adding} label={err.name} error onChange={(e:any) => setBranch({...branch,name:e.target.value})}/> </Col>
            </Row>
            <Row>
                <Col><Button style={{ float:"right"}} onClick={onAdd} disabled={adding}>Add</Button></Col>
            </Row>
        </Stack>
        
    </>
}

export default AddBranchView